import {
  sendGetRequest, sendPostRequest, sendDeleteRequest, sendPatchRequest
} from "@/helper/requests";
import surveys from "@/urls/roles/admin";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
  // Main choice
  loadChoiceList: ({commit}, {url, finalizer, catcher}) => {
    /**
     * Загружает список всех вариантов выбора
     * @param {Function} commit - Функция для вызова мутаций
     * @param {string} url - URL для запроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    if (!url) url = surveys.ADMIN.CHOICES.LIST()
    sendGetRequest(
      url,
      (data) => finalizer(data, url),
      catcher
    )
  },
  loadChoiceDetail: ({commit, getters}, {id, finalizer, catcher}) => {
    /**
     * Загружает детальную информацию о конкретном варианте выбора
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Function} getters - Геттеры Vuex
     * @param {number} id - Идентификатор варианта выбора
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICES.DETAIL(id)
    sendGetRequest(url, finalizer, catcher)
  },
  createChoice: ({dispatch, commit}, {data, finalizer, catcher}) => {
    /**
     * Создает новый вариант выбора
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Данные для создания варианта выбора
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICES.SAVE()
    sendPostRequest(url, data, finalizer, catcher)
  },
  updateChoice: ({dispatch, commit}, {id, data, finalizer, catcher}) => {
    /**
     * Обновляет существующий вариант выбора
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор варианта выбора
     * @param {Object} data - Обновленные данные варианта выбора
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICES.EDIT(id)
    sendPatchRequest(
      url, data, finalizer, catcher
    )
  },
  deleteChoice: ({dispatch, commit}, {id, finalizer, catcher}) => {
    /**
     * Удаляет вариант выбора
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор варианта выбора для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICES.DELETE(id)
    sendDeleteRequest(url, finalizer, catcher)
  },
  // Choice values
  loadChoiceValueList: ({commit}, {value_choices_id, finalizer, catcher}) => {
    /**
     * Загружает список значений для конкретного варианта выбора
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} value_choices_id - Идентификатор родительского варианта выбора
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICE_VALUE.LIST(value_choices_id)
    sendGetRequest(url, finalizer, catcher)
  },
  loadChoiceValueDetail: ({commit, getters}, {value_choices_id, id, finalizer, catcher}) => {
    /**
     * Загружает детальную информацию о значении варианта выбора
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Function} getters - Геттеры Vuex
     * @param {number} value_choices_id - Идентификатор родительского варианта выбора
     * @param {number} id - Идентификатор значения
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICE_VALUE.DETAIL(value_choices_id, id)
    sendGetRequest(url, finalizer, catcher)
  },
  createChoiceValue: ({dispatch, commit}, {value_choices_id, data, finalizer, catcher}) => {
    /**
     * Создает одно значение для варианта выбора
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} value_choices_id - Идентификатор родительского варианта выбора
     * @param {Object} data - Данные для создания значения
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICE_VALUE.ONE_CREATE(value_choices_id)
    sendPostRequest(url, data, finalizer, catcher)
  },
  changeListOfChoiceValue: ({dispatch, commit}, {value_choices_id, data, finalizer, catcher}) => {
    /**
     * Массово создает или изменяет список значений варианта выбора
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} value_choices_id - Идентификатор родительского варианта выбора
     * @param {Array} data - Массив данных значений для массового создания/обновления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICE_VALUE.MANY_CREATE(value_choices_id)
    sendPostRequest(url, data, finalizer, catcher)
  },
  updateChoiceValue: ({dispatch, commit}, {value_choices_id, data, finalizer, catcher}) => {
    /**
     * Обновляет значение варианта выбора
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {string|number} value_choices_id - Идентификатор родительского варианта выбора
     * @param {Object} data - Обновленные данные значения
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICE_VALUE.EDIT(value_choices_id, data.id)
    sendPatchRequest(
      url, data, finalizer, catcher
    )
  },
  deleteChoiceValue: ({dispatch, commit}, {value_choices_id, id, finalizer, catcher}) => {
    /**
     * Удаляет значение варианта выбора
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} value_choices_id - Идентификатор родительского варианта выбора
     * @param {number} id - Идентификатор значения для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.CHOICE_VALUE.DELETE(value_choices_id, id)
    sendDeleteRequest(url, finalizer, catcher)
  },
}


export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
